<template>
  <div class="autocomplete-input">
    <div class="input-group">
      <input
        ref="input"
        :placeholder="placeholder"
        type="text"
        @change="testing"
        @selected="$emit('selected', { fromEvent: true, input, autocomplete })"
      />
      <p v-if="error" class="error">
        {{
          "Osoite on virheellinen. Yritä uudelleen siten, että syötät kenttään vain postinumeron."
        }}
      </p>
    </div>
    <button
      v-if="showButton"
      aria-label="Hae osoite"
      class="btn btn-primary no-arrow"
      @click="$emit('selected', { fromEvent: false, input, autocomplete })"
    >
      <i v-if="!loading" class="fal fa-search"></i>
      <i v-else class="fal fa-spinner-third loading-icon"></i>
    </button>
  </div>
</template>

<script>
import { mapState, useStore } from "vuex";
import { onMounted, ref } from "vue";
import { get, set, unrefElement } from "@vueuse/core";
import { enableEnterKey } from "../helpers";

import gmaps from "@/shared/gmaps";

export default {
  name: "AutocompleteInput",
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "Syötä osoite",
    },
  },
  emits: ["selected"],
  setup() {
    const store = useStore();

    const input = ref(null);

    const autocomplete = ref(null);

    let google;

    onMounted(async () => {
      google = await gmaps();

      const options = {
        componentRestrictions: { country: "fi" },
        fields: ["address_components", "geometry"],
        strictBounds: false,
        types: ["address"],
      };

      set(
        autocomplete,
        new google.maps.places.Autocomplete(unrefElement(input), options)
      );

      if (store.getters.getAddressLine !== "")
        input.value.value = store.getters.getAddressLine;

      enableEnterKey(unrefElement(input));
    });

    return { input, autocomplete, google };
  },
  computed: {
    ...mapState(["address_info"]),
  },
  watch: {
    address_info(newValue) {
      const input = get(this.input);
      if (newValue.addressLine !== input.value) {
        input.value = newValue.addressLine;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete-input {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .input-group {
    input {
      min-width: 300px;
      @media screen and (max-width: 768px) {
        min-width: 240px;
      }
      width: 100%;
      border: 0;
      border-radius: 0.25rem 0 0 0.25rem;
      padding: 1rem 2rem;
      font-size: 20px;
    }
  }

  p.error {
    white-space: break-spaces;
    font-size: 16px;
    margin: 0.5rem 0 0;
    color: #d4662d;
  }

  button {
    height: 100%;
    padding: 0.75rem 2rem;
    align-self: flex-start;
    border-color: var(--bs-green);
    background-color: var(--bs-green);
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    margin-bottom: 0;

    i {
      font-size: 32px;

      &.loading-icon {
        animation: spin 2000ms infinite linear;
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}
</style>
